import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { EkoThemeService } from '@ekowitryna/ui';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private readonly document = inject(DOCUMENT);
  private readonly themeService = inject(EkoThemeService);

  toogleTheme(): void {
    this.themeService.setTheme(this.themeService.isDark ? 'LIGHT' : 'DARK');
  }

  get isDarkMode(): boolean {
    return this.document.documentElement.classList.contains('dark');
  }

  get darkMode(): boolean {
    return this.themeService.isDark;
  }
}
